const  pageloader = {
    page_loader : "Loader/Pageopen/loader.gif"
};
export default pageloader